const { default: axios } = require("axios");
window.$ = window.jQuery = require("jquery");

require("./plugins/modernizr-custom");
require("./bootstrap");

import "lazysizes";
// import a plugin
import "lazysizes/plugins/parent-fit/ls.parent-fit";

$("#abre-menu").on("click", function (e) {
    if ($(".visible").length) {
        $("#menu").removeClass("visible");
    } else {
        $("#menu").addClass("visible");
    }
});

$("#cerrar-menu").on("click", function (e) {
    $("#menu").removeClass("visible");
});

/* $(document).on("click", function(event) {
    const $target = $(event.target);
    console.log($target.closest("#menu").length, $("#menu.visible").length);
    if (!$target.closest("#menu").length && $("#menu.visible").length) {
        $("#menu").removeClass("visible");
    }
}); */

$(".up").on("click", function (e) {
    $([document.documentElement, document.body]).animate(
        {
            scrollTop: 0
        },
        1000
    );
});

$(window).scroll(function () {
    let scrollTop = $(this).scrollTop();

    if (scrollTop > 5) {
        $("header, body").addClass("scroll");
    } else {
        $("header, body").removeClass("scroll");
    }
});

$(document).ready(function () {
    $("#loading").fadeOut(function () {
        $(this).remove();
    });
});

$(".busca-proyecto").on("click", function (e) {
    e.preventDefault();
    const ciudad = $("#select_ciudad").val();
    const tipo = $("#select_tipo").val();
    let url = $(this).attr("href");
    url = `${url}/${ciudad}/${tipo}/todo `;
    document.location = url;
});

$(".busca-proyecto_inferior").on("click", function (e) {
    e.preventDefault();
    const ciudad = $("#select_ciudad_inferior").val();
    const tipo = $("#select_tipo_inferior").val();
    let url = $(this).attr("href");
    url = `${url}/${ciudad}/${tipo}/todo `;
    document.location = url;
});

$(document).ready(function () {
    $(".add-event").on("click", function () {
        const data = {
            event: $(this).data("evento"),
            project: $(this).data("proyecto")
        };
        axios.post("/add-event", data);
    });

    $(".scroll-to").click(function (e) {
        e.preventDefault();
        const target_id = $(this).attr("href");
        const $toElement = $(target_id);

        if ($toElement.length) {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $toElement.offset().top
                },
                1000
            );
        }

        $(".modal").modal("hide");

        return false;
    });

    $('#modal-banco-estado').show();
    $('#close-modal-banco-estado').on('click', function () {
        $('#modal-banco-estado').hide();
    });
    require("./modal_promocion");

});
